import { GameState } from '../../core/GameState.js';
import { formatDuration } from '../../utils/formatting.js';
import { estimateShipSchedule } from '../../utils/schedule.js';

/**
 * Contract-deadline schedule wording for the Fleet card chip and the Details
 * "Deadline" row (#53-T8d). Wording carries the meaning; colour is secondary.
 */

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const CLASS_BY_STATUS = { onTime: 'ontime', behind: 'behind', late: 'late', unknown: 'unknown' };

function _shortDate(date) {
  return `${MONTHS[date.getMonth()]} ${String(date.getDate()).padStart(2, '0')}`;
}

function _hours(hours) {
  const h = Math.abs(hours);
  return h < 1 ? 'under 1 hr' : formatDuration(h / 24);
}

/**
 * Pure text builder.
 * @param {{status:string, deadline:Date|null, slackHours:number|null}} schedule  estimateShipSchedule result
 * @returns {{cls:string, text:string}|null} null when nothing should be shown
 */
export function describeSchedule(schedule) {
  if (!schedule || !CLASS_BY_STATUS[schedule.status] || !schedule.deadline) return null;
  const date = _shortDate(schedule.deadline);
  const cls = CLASS_BY_STATUS[schedule.status];
  switch (schedule.status) {
    case 'onTime':
      return { cls, text: `On time - deadline ${date} (${_hours(schedule.slackHours)} spare)` };
    case 'behind':
      return { cls, text: `Behind - ${_hours(schedule.slackHours)} spare before ${date} deadline` };
    case 'late':
      return schedule.slackHours == null
        ? { cls, text: `Will miss deadline ${date}` }
        : { cls, text: `Will miss deadline ${date} by ${_hours(schedule.slackHours)}` };
    default:
      return { cls, text: `Deadline ${date} - ETA unknown` };
  }
}

function _describe(ship) {
  if (!ship) return null;
  const schedule = estimateShipSchedule(ship, {
    now: GameState.currentDate,
    contracts: GameState.contracts?.active,
    tradeRoutes: GameState.tradeRoutes
  });
  return describeSchedule(schedule);
}

/** Card chip; '' when the voyage has no active contract deadline. */
export function scheduleChipHtml(ship) {
  const d = _describe(ship);
  return d ? `<span class="ship-schedule ship-schedule--${d.cls}">${d.text}</span>` : '';
}

/** Details-view "Deadline" table row; '' when none. */
export function scheduleRowHtml(ship) {
  const d = _describe(ship);
  return d ? `<tr><td>Deadline</td><td><span class="ship-schedule ship-schedule--${d.cls}">${d.text}</span></td></tr>` : '';
}
